import React from 'react';
import { Props } from './header.type';

function Header({ currentStep, total }: Props) {
  return (
    <header>
      <h5>React js</h5>
      <span>
        Question {currentStep} of {total}
      </span>
    </header>
  );
}

export default Header;
